import { Button } from '@/components/ui/button';
import { Progress } from '@/components/ui/progress';
import { useLingui } from '@lingui/react';
import { msg } from '@lingui/macro';
import { X } from 'lucide-react';

interface ContractWizardHeaderProps {
  currentStep: string;
  stepIndex: number;
  totalSteps: number;
  progress: number;
  onClose: () => void;
  stepTitle?: string;
}

export function ContractWizardHeader({
  currentStep,
  stepIndex,
  totalSteps,
  progress,
  onClose,
  stepTitle,
}: ContractWizardHeaderProps) {
  const { i18n } = useLingui();

  return (
    <div className="px-6 py-4 border-b">
      <div className="flex items-center justify-between">
        <h2 id={`step-${currentStep}`} className="text-2xl font-semibold">
          {i18n._(msg`Create Contract`)}
        </h2>
        <Button 
          variant="ghost" 
          size="icon" 
          onClick={onClose}
          aria-label={i18n._(msg`Close wizard`)}
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
      
      {/* Progress indicator with accessibility */}
      <div 
        className="mt-4 space-y-2"
        role="navigation"
        aria-label={i18n._(msg`Wizard progress`)}
      >
        <div className="flex justify-between text-sm text-muted-foreground">
          <span aria-live="polite">
            {i18n._(msg`Step ${stepIndex + 1} of ${totalSteps}`)}
          </span>
          <span aria-current="step">{stepTitle || i18n._(currentStep)}</span>
        </div>
        <Progress 
          value={progress} 
          className="h-2"
          aria-label={i18n._(msg`Progress: ${Math.round(progress)}% complete`)}
          aria-valuenow={Math.round(progress)}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
    </div>
  );
}